import { onDomReady } from './helpers';
import { lazyLoadImages } from './lazyload';

function togglePasswordVisibility() {
    const toggles = document.querySelectorAll('.show-password');

    toggles.forEach(toggle => {
        toggle.addEventListener('click', () => {
            const label = toggle.parentNode;
            const input = label.querySelector('input');

            if (input.type === 'password') {
                input.type = 'text';
                toggle.classList.add('active');
            } else {
                input.type = 'password';
                toggle.classList.remove('active');
            }
        });
    });
}

onDomReady(() => {
    togglePasswordVisibility();
    lazyLoadImages();
});
